export default {
  MuiAutocomplete: {
    styleOverrides: {
      listbox: {
        padding: 0
      },
      option: {
        paddingTop: '3px',
        paddingLeft: '15px',
        paddingRight: '15px',
        paddingBottom: '3px'
      },
      paper: {
        borderRadius: 0
      },
      inputRoot: {
        minHeight: '32px !important',
        padding: '8px 8px !important',
        '& > input': {
          padding: '4.5px 4px 4.5px 6px !important',
          fontSize: '14px'
        }
      }
    }
  }
};
